module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av456-388ffbc2e8370809faff513b479c9766.jpg";